import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './core/layout/components/footer/footer.component';
import { ToolbarComponent } from './core/layout/components/toolbar/toolbar.component';
import { DecideComponent } from './features/decide/decide.component';
import { PrepareComponent } from './features/prepare/prepare.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ToolbarComponent,
    FooterComponent,
    MatProgressSpinnerModule,
    MatTabsModule,
    DecideComponent,
    PrepareComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'cms-se';
}
